import { _ } from '../utils.js'
import YouTubeIframeLoader from 'youtube-iframe'

export default class Video {
    constructor(el) {
        this.el = el
        this.video = _('video-player', 'element').nodeFrom(this.el)
        this.playVideo = _('video-play').nodeFrom(this.el)
        this.pauseVideo = _('video-pause').nodeFrom(this.el)
        this.activeClass = el.dataset.activeClass
        const self = this
        const videoId = this.video.dataset.videoId
        const id = this.video.getAttribute('id')

        YouTubeIframeLoader.load(function (YT) {
            self.player = new YT.Player(id, {
                height: '495',
                width: '880',
                videoId: videoId,
                playerVars: { rel: 0, origin: window.location.href },
                events: {
                    onReady: self.ytPlayerReady,
                },
            })
        })
    }

    ytPlayerReady = () => {
        this.playVideo.addEventListener('click', this.ytPlayVideo)
        this.pauseVideo.addEventListener('click', this.ytPauseVideo)
    }

    ytPlayVideo = () => {
        this.player.playVideo()
        this.el.classList.add(this.activeClass)
    }

    ytPauseVideo = () => {
        this.player.pauseVideo()
        this.el.classList.remove(this.activeClass)
    }
}
